import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Button, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Spinner from '../../shared/spinner';
import { ButtonAlterar, ButtonAtivar, ButtonInativar } from '../../shared/buttons';
import { format } from 'date-fns';
import { faFileExcel, faFilter, faRefresh } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import InputMask from 'react-input-mask';
import { FiltroUsuarioDTO } from '../../shared/dto/filtroUsuarioDTO';
import ResponsivePagination from 'react-responsive-pagination';
import UsuarioService from '../../services/usuarioService';
import CustomAlert from '../../shared/customAlert';
import ConfirmModal from '../../shared/customAlertConfirm';
import { Role } from '../../shared/model/role';
import { UUID } from 'crypto';
import { UsuarioDTO } from '../../shared/dto/usuarioDTO';
import { useVerificaPermissao } from '../../shared/useVerificaPermissao';
import RelatorioService from '../../services/relatorioService';
import AlcadaService from '../../services/alcadaService';
import { Alcada } from '../../shared/model/alcada';
import { useSlug } from '../hooks/UseSlug';
import { ProtectedAction } from '../../AccessControl';

function AlcadaEsteiraComponent() {
  useVerificaPermissao();
  const slug = useSlug(); // 2. Obtendo o slug
  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);

  const statusFl = [
    { value: 'Todos', label: 'Todos' },
    { value: 'Ativos', label: 'Ativos' },
    { value: 'Inativos', label: 'Inativos' },
  ];

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [usuarios, setUsuarios] = useState<UsuarioDTO[]>([]);
  const [roles, setRoles] = useState<Role[]>([]);
  const [alcadas, setAlcadas] = useState<Alcada[]>([]);

  const [filtros, setFiltros] = useState(false);
  const [codigoFiltro, setCodigoFiltro] = useState('');
  const [loginFiltro, setLoginFiltro] = useState('');
  const [nomeFiltro, setNomeFiltro] = useState('');
  const [cpfFiltro, setCpfFiltro] = useState('');
  const [statusFiltro, setStatusFiltro] = useState(statusFl[0].value);
  const [roleFiltro, setRoleFiltro] = useState<Role>();
  const [dataInicioFiltro, setDataInicioFiltro] = useState<Date | undefined>();
  const [dataFimFiltro, setDataFimFiltro] = useState<Date | undefined>();

  const qtdRegistros = [10, 20, 30, 50, 100];
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const relatorioService: RelatorioService = new RelatorioService();
  const usuarioService: UsuarioService = new UsuarioService();
  const alcadaServive: AlcadaService = new AlcadaService();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [currentAction, setCurrentAction] = useState<{ id: any; ativo: boolean } | null>(null);


  const [nomeAlcada, setNomeAlcada] = useState('');
  const [tipoAcesso, setTipoAcesso] = useState('I');
  const [valorAlcada, setValorAlcada] = useState('');
  const [faseAlcada, setFaseAlcada] = useState('');

  const listarTodosUsuarios1 = async (max: number) => {

    try {
      setLoading(true);

      let filtro = new FiltroUsuarioDTO();
      filtro.codigo = codigoFiltro;
      filtro.nome = nomeFiltro;

      const responseList = await usuarioService.listarTodosUsuarios(currentPage, max, filtro);
      const jsonList: UsuarioDTO[] = responseList.data.content;
      setUsuarios(jsonList);
      setTotalPages(responseList.data.totalPages);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  const listarTodasAlcadas = async (page: number = currentPage, max: number = pageSize) => {
    try {
      setLoading(true);

      //Garante que nunca mande page negativa para a API
      const safePage = Math.max(page - 1, 0);

      const responseList = await alcadaServive.listarTodasAlcadas(safePage, max);
      
      const content: Alcada[] = responseList.data.content;
      const total: number = responseList.data.totalPages;

      setAlcadas(content);
      setTotalPages(total);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const ativarInativarUsuario = async (id: any, ativo: boolean) => {
    setCurrentAction({ id, ativo });
    setConfirmOpen(true);
  };

  const handleConfirm = async () => {
    if (currentAction) {
      const { id, ativo } = currentAction;

      try {
        await usuarioService.ativarInativarUsuario(id);
        // listarTodosUsuarios(pageSize);
        listarTodasAlcadas();
      } catch (err) {
        console.error(err);
      } finally {
        setConfirmOpen(false);
        setCurrentAction(null);
      }
    }
  };

  const excluirAlcada = async (id: number | string) => {
    setLoading(true);
    try {
      await alcadaServive.excluirAlcada(id)
      listarTodasAlcadas();
      setLoading(false);
      setAlert({ message: 'Alçada excluída com sucesso!', type: 'success' });
    } catch (err) {
      setLoading(false);
      setAlert({ message: 'Erro ao excluir Alçada!', type: 'success' });
      console.error(err);
    }
  }

  const gerarRelatorio = async () => {
    setLoading(true);
    try {
      let filtro = new FiltroUsuarioDTO();
      filtro.codigo = codigoFiltro;
      filtro.nome = nomeFiltro;

      const response = await relatorioService.gerarRelatorioUsuarios(filtro);

      const contentType = response.headers['content-type'];

      if (contentType === 'text/plain') {
        const errorText = await response.data.text();
        setAlert({ message: errorText, type: 'warning' });
      } else {
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        link.setAttribute('download', 'Relatorio_Usuarios.xlsx');

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }

      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      if (err.response && err.response.status === 500 && err.response.data instanceof Blob) {
        const errorText = await err.response.data.text();
        setAlert({ message: errorText, type: 'warning' });
      } else if (err.response && err.response === 'AXIOS_TIMEOUT') {
        setAlert({ message: 'Ocorreu um erro ao gerar o relatório', type: 'error' });
      }
      console.error(err);
    }
  };

  const listarRoles = async () => {
    try {
      const response = await usuarioService.listarRoles();
      setRoles(response.data);
    } catch (err: any) {
      console.error(err);
    }
  };

  useEffect(() => {
    // listarTodosUsuarios(pageSize);
    listarTodasAlcadas();
    listarRoles();
  }, [currentPage]);

  return (
    <>
      {alert && (<CustomAlert message={alert.message} type={alert.type} onClose={() => setAlert(null)} />)}
      <div className="position-relative m-md-3">
        <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between' }}>
          <h5>Alçadas Esteira</h5>
        </div>

        <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between' }}>
          {/* <Button id="App-button-cor-principal-escura" onClick={() => setFiltros(!filtros)}>
            <FontAwesomeIcon icon={faFilter} style={{ marginRight: '10px' }} />
            Filtros
          </Button> */}
          <div>
          <ProtectedAction>
            <Button
              // 3. Rota corrigida com Slug
              onClick={() => navigate(`/${slug}/sistema-alcadas-esteira/inclusao`, { state: { id: 0 } })}
              id="App-button-cor-principal-escura"
            >
              + Nova Alçada
            </Button>
          </ProtectedAction>  
          </div>
        </div>
        {filtros ?
          <>
            <Row className="mb-4" style={{ marginTop: '15px' }}>
              <Form.Group as={Col} md='2' controlId="formBasicSelect">
                <Form.Label>Código Alçada </Form.Label>
                <input type="text" className="form-control" value={codigoFiltro} onChange={(e) => setCodigoFiltro(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md='4' controlId="formBasicSelect">
                <Form.Label>Nome </Form.Label>
                <input type="text" className="form-control" value={nomeFiltro} onChange={(e) => setNomeFiltro(e.target.value)} />
              </Form.Group>
            </Row>
            <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between' }}>
              <Button id="App-button-cor-principal-escura" onClick={() => setFiltros(!filtros)}>
                <FontAwesomeIcon icon={faFilter} style={{ marginRight: '1px' }} />
              </Button>
              {/* <Button id="App-button-cor-principal-escura" onClick={() => listarTodosUsuarios(pageSize)}> */}
              <Button id="App-button-cor-principal-escura" onClick={() => listarTodasAlcadas()}>
                <FontAwesomeIcon icon={faRefresh} style={{ marginRight: '1px' }} />
              </Button>
            </div>
          </>
          : null}

        <Row style={{ justifyContent: 'center' }} className="mb-3">
          <Form.Group style={{ marginTop: '10px' }} as={Col} md='2' controlId="formBasicSelect">Registros Por Página</Form.Group>
          <Form.Group as={Col} md='1' controlId="formBasicSelect">
            <select
              className="form-select"
              defaultValue={pageSize}
              value={pageSize}
              onChange={(e) => {
                const newSize = parseInt(e.target.value);
                setPageSize(newSize);
                setCurrentPage(1); //reinicia para página 1
                listarTodasAlcadas(1, newSize); //valores atualizados
              }}
            >

              {qtdRegistros.map((qtd, index) => (
                <option key={index} value={qtd}>{qtd}</option>
              ))}
            </select>
          </Form.Group>
        </Row>

        {loading ? <Spinner loading={loading} /> : (
          <div className="table-responsive">
            <div>
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th scope="col" id="App-header-table" style={{ width: '5%' }}>Código</th>
                    <th scope="col" id="App-header-table" style={{ width: '65%'}}>Nome</th>
                    <ProtectedAction> 
                      <th scope="col" id="App-header-table" style={{ width: '15%'}}>Alterar</th>
                      <th scope="col" id="App-header-table" style={{ width: '15%'}}>Excluir</th>
                    </ProtectedAction>   
                  </tr>
                </thead>
                <tbody>
                  {alcadas.map((item) => (
                    <tr>
                      <td>{item.id}</td>
                      <td>{item.nomeAlcada}</td>
                      <ProtectedAction> 
                        <td style={{ textAlign: 'center' }}>
                          {/* 4. Link de alteração com Slug */}
                          <Link to={`/${slug}/sistema-alcadas-esteira/alteracao`} state={{ id: item.id }}>
                            <ButtonAlterar />
                          </Link>
                        </td>
                        <td style={{ textAlign: 'center' }}>
                        <ButtonInativar onClick={() => excluirAlcada(item.id!)} />
                          
                        </td>
                      </ProtectedAction> 
                    </tr>
                  ))}
                </tbody>
              </table>
              {confirmOpen && (<ConfirmModal message={currentAction?.ativo ? 'Tem certeza que deseja inativar este item?' : 'Tem certeza que deseja ativar este item?'} onConfirm={handleConfirm} onCancel={() => { setConfirmOpen(false); setCurrentAction(null) }} />)}
              <ResponsivePagination
                current={currentPage}
                total={totalPages}
                onPageChange={(page) => {
                  setCurrentPage(page);
                  listarTodasAlcadas(page, pageSize); //valores atualizados
                }}
              />

            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default AlcadaEsteiraComponent;